const sCompanyData = {
  data () {
    return {
      pageDto: {
        page: 1,
        size: 10,
        param: {}
      }
    }
  }
}

export default sCompanyData
